import instance from '../utils/axios';

class OrderService {
    async getOrderById(uuid) {
        return await instance.get('/crm/order/getOrderById?uuid='+uuid);
    }

    async getReceiptList(pageIndex,orderId) {
        return await instance.post('/crm/contract/getReceivablesPlanList?orderId='+orderId, {
            pageSize: 10,
            pageIndex: pageIndex,
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            sortField: 'planReceiptDate',
            sort: 'asc'
        });
    }

    async getCashFlowList(pageIndex,orderId) {
        return await instance.post('/crm/receipt/getCashFlowList?orderId='+orderId, {
            pageSize: 10,
            pageIndex: pageIndex,
            dictionaryNames: 'paymentType.dict_payment_type',
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            sortField: 'createTime',
            sort: 'desc'
        });
    }

    async getInvoiceRecordList(pageIndex,orderId) {
        return await instance.post('/crm/invoiced/getInvoiceRecordList?orderId='+orderId, {
            pageSize: 10,
            pageIndex: pageIndex,
            dictionaryNames: 'invoiceType.dict_invoice_type',
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            sortField: 'createTime',
            sort: 'desc'
        });
    }

    async getReceiptSummaryList(pageIndex,startTime,endTime,status) {
        return await instance.post('/crm/receipt/getReceiptSummary?startTime='+startTime+'&endTime='+endTime+'&status='+status, {
            pageSize: 10,
            pageIndex: pageIndex,
            expressions: '[{"field": "数量", "expression": "count(1)"}]',
            sortField: 'planReceiptDate',
            sort: 'desc'
        });
    }

    async getReceiptSummaryStatistics(startTime,endTime) {
        return await instance.get('/crm/receipt/getReceiptSummaryStatistics?startTime='+startTime+'&endTime='+endTime);
    }
}

export default new OrderService();